// This file is auto-generated by @hey-api/openapi-ts
import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from './client';
import { client } from './client.gen';
import type {
  CreateSubmissionData,
  CreateSubmissionResponses,
  CreateSubmissionTemplateData,
  CreateSubmissionTemplateErrors,
  CreateSubmissionTemplateResponses,
  DeleteProfileData,
  DeleteProfileErrors,
  DeleteProfileResponses,
  DeleteSubmissionTemplateData,
  DeleteSubmissionTemplateErrors,
  DeleteSubmissionTemplateResponses,
  DeleteTestProfilesData,
  DeleteTestProfilesErrors,
  DeleteTestProfilesResponses,
  GetAllSurveysData,
  GetAllSurveysErrors,
  GetAllSurveysResponses,
  GetAllSurveyVersionsData,
  GetAllSurveyVersionsErrors,
  GetAllSurveyVersionsResponses,
  GetAnalyticsForMySubmissionData,
  GetAnalyticsForMySubmissionErrors,
  GetAnalyticsForMySubmissionResponses,
  GetAnalyticsForSubmissionData,
  GetAnalyticsForSubmissionErrors,
  GetAnalyticsForSubmissionResponses,
  GetCurrentSurveyVersionData,
  GetCurrentSurveyVersionResponses,
  GetMyProfileData,
  GetMyProfileErrors,
  GetMyProfileResponses,
  GetMySubmissionData,
  GetMySubmissionErrors,
  GetMySubmissionResponses,
  GetMySubmissionsData,
  GetMySubmissionsErrors,
  GetMySubmissionsResponses,
  GetProfileData,
  GetProfileErrors,
  GetProfileResponses,
  GetSpecificSurveyVersionData,
  GetSpecificSurveyVersionErrors,
  GetSpecificSurveyVersionResponses,
  GetSubmissionData,
  GetSubmissionErrors,
  GetSubmissionResponses,
  GetSubmissionsData,
  GetSubmissionsErrors,
  GetSubmissionsResponses,
  GetSubmissionTemplateData,
  GetSubmissionTemplateErrors,
  GetSubmissionTemplateResponses,
  GetSubmissionTemplatesData,
  GetSubmissionTemplatesErrors,
  GetSubmissionTemplatesResponses,
  GetSurveyData,
  GetSurveyErrors,
  GetSurveyResponses,
  LocalSignInEndpointData,
  LocalSignInEndpointResponses,
  LogoutData,
  LogoutResponses,
  OAuthSignInData,
  OAuthSignInErrors,
  OAuthSignInResponses,
  SearchProfilesData,
  SearchProfilesErrors,
  SearchProfilesResponses,
  UpdateMySubmissionResponsesData,
  UpdateMySubmissionResponsesErrors,
  UpdateMySubmissionResponsesResponses,
  UpdateSubmissionResponsesData,
  UpdateSubmissionResponsesErrors,
  UpdateSubmissionResponsesResponses,
  UpdateSubmissionTemplateData,
  UpdateSubmissionTemplateErrors,
  UpdateSubmissionTemplateResponses,
} from './types.gen';

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
  TResponse = unknown,
> = Options2<TData, ThrowOnError, TResponse> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Retrieves all versions of a survey with pagination.
 */
export const getAllSurveyVersions = <ThrowOnError extends boolean = true>(
  options: Options<GetAllSurveyVersionsData, ThrowOnError>,
): RequestResult<GetAllSurveyVersionsResponses, GetAllSurveyVersionsErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).get<GetAllSurveyVersionsResponses, GetAllSurveyVersionsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/survey/{surveySlug}/versions',
    ...options,
  });

/**
 * Retrieves the current published version of a survey.
 */
export const getCurrentSurveyVersion = <ThrowOnError extends boolean = true>(
  options: Options<GetCurrentSurveyVersionData, ThrowOnError>,
): RequestResult<GetCurrentSurveyVersionResponses, unknown, ThrowOnError, 'data'> =>
  (options.client ?? client).get<GetCurrentSurveyVersionResponses, unknown, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/survey/{surveySlug}/versions/current',
    ...options,
  });

/**
 * Retrieves a specific numbered version of a survey.
 */
export const getSpecificSurveyVersion = <ThrowOnError extends boolean = true>(
  options: Options<GetSpecificSurveyVersionData, ThrowOnError>,
): RequestResult<GetSpecificSurveyVersionResponses, GetSpecificSurveyVersionErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).get<
    GetSpecificSurveyVersionResponses,
    GetSpecificSurveyVersionErrors,
    ThrowOnError,
    'data'
  >({
    responseStyle: 'data',
    url: '/survey/{surveySlug}/versions/{version}',
    ...options,
  });

/**
 * Retrieves all surveys with optional filtering and pagination.
 */
export const getAllSurveys = <ThrowOnError extends boolean = true>(
  options: Options<GetAllSurveysData, ThrowOnError>,
): RequestResult<GetAllSurveysResponses, GetAllSurveysErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).get<GetAllSurveysResponses, GetAllSurveysErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/survey',
    ...options,
  });

/**
 * Retrieves a survey by slug.
 */
export const getSurvey = <ThrowOnError extends boolean = true>(
  options: Options<GetSurveyData, ThrowOnError>,
): RequestResult<GetSurveyResponses, GetSurveyErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).get<GetSurveyResponses, GetSurveyErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/survey/{surveySlug}',
    ...options,
  });

/**
 * Soft-deletes an existing submission template.
 */
export const deleteSubmissionTemplate = <ThrowOnError extends boolean = true>(
  options: Options<DeleteSubmissionTemplateData, ThrowOnError>,
): RequestResult<DeleteSubmissionTemplateResponses, DeleteSubmissionTemplateErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).delete<
    DeleteSubmissionTemplateResponses,
    DeleteSubmissionTemplateErrors,
    ThrowOnError,
    'data'
  >({
    responseStyle: 'data',
    url: '/survey/{surveySlug}/templates/{templateId}',
    ...options,
  });

/**
 * Retrieves a specific submission template belonging to a survey.
 */
export const getSubmissionTemplate = <ThrowOnError extends boolean = true>(
  options: Options<GetSubmissionTemplateData, ThrowOnError>,
): RequestResult<GetSubmissionTemplateResponses, GetSubmissionTemplateErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).get<GetSubmissionTemplateResponses, GetSubmissionTemplateErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/survey/{surveySlug}/templates/{templateId}',
    ...options,
  });

/**
 * Updates the responses on an existing submission template.
 */
export const updateSubmissionTemplate = <ThrowOnError extends boolean = true>(
  options: Options<UpdateSubmissionTemplateData, ThrowOnError>,
): RequestResult<UpdateSubmissionTemplateResponses, UpdateSubmissionTemplateErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).put<
    UpdateSubmissionTemplateResponses,
    UpdateSubmissionTemplateErrors,
    ThrowOnError,
    'data'
  >({
    responseStyle: 'data',
    url: '/survey/{surveySlug}/templates/{templateId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Retrieves all submission templates belonging to a survey.
 */
export const getSubmissionTemplates = <ThrowOnError extends boolean = true>(
  options: Options<GetSubmissionTemplatesData, ThrowOnError>,
): RequestResult<GetSubmissionTemplatesResponses, GetSubmissionTemplatesErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).get<GetSubmissionTemplatesResponses, GetSubmissionTemplatesErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/survey/{surveySlug}/templates',
    ...options,
  });

/**
 * Creates a reusable submission template from an existing submission.
 */
export const createSubmissionTemplate = <ThrowOnError extends boolean = true>(
  options: Options<CreateSubmissionTemplateData, ThrowOnError>,
): RequestResult<CreateSubmissionTemplateResponses, CreateSubmissionTemplateErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).post<
    CreateSubmissionTemplateResponses,
    CreateSubmissionTemplateErrors,
    ThrowOnError,
    'data'
  >({
    responseStyle: 'data',
    url: '/survey/{surveySlug}/templates',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Retrieves a specific submission.
 */
export const getSubmission = <ThrowOnError extends boolean = true>(
  options: Options<GetSubmissionData, ThrowOnError>,
): RequestResult<GetSubmissionResponses, GetSubmissionErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).get<GetSubmissionResponses, GetSubmissionErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/profile/{profileId}/submissions/{submissionId}',
    ...options,
  });

/**
 * Updates the answers on an existing submission.
 */
export const updateSubmissionResponses = <ThrowOnError extends boolean = true>(
  options: Options<UpdateSubmissionResponsesData, ThrowOnError>,
): RequestResult<UpdateSubmissionResponsesResponses, UpdateSubmissionResponsesErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).put<
    UpdateSubmissionResponsesResponses,
    UpdateSubmissionResponsesErrors,
    ThrowOnError,
    'data'
  >({
    responseStyle: 'data',
    url: '/profile/{profileId}/submissions/{submissionId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Retrieves one of the current user's own submissions.
 */
export const getMySubmission = <ThrowOnError extends boolean = true>(
  options: Options<GetMySubmissionData, ThrowOnError>,
): RequestResult<GetMySubmissionResponses, GetMySubmissionErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).get<GetMySubmissionResponses, GetMySubmissionErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/profile/me/submissions/{submissionId}',
    ...options,
  });

/**
 * Updates the answers on one of the current user's own submissions.
 */
export const updateMySubmissionResponses = <ThrowOnError extends boolean = true>(
  options: Options<UpdateMySubmissionResponsesData, ThrowOnError>,
): RequestResult<UpdateMySubmissionResponsesResponses, UpdateMySubmissionResponsesErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).put<
    UpdateMySubmissionResponsesResponses,
    UpdateMySubmissionResponsesErrors,
    ThrowOnError,
    'data'
  >({
    responseStyle: 'data',
    url: '/profile/me/submissions/{submissionId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Retrieves analytics for a specific submission.
 */
export const getAnalyticsForSubmission = <ThrowOnError extends boolean = true>(
  options: Options<GetAnalyticsForSubmissionData, ThrowOnError>,
): RequestResult<GetAnalyticsForSubmissionResponses, GetAnalyticsForSubmissionErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).get<
    GetAnalyticsForSubmissionResponses,
    GetAnalyticsForSubmissionErrors,
    ThrowOnError,
    'data'
  >({
    responseStyle: 'data',
    url: '/profile/{profileId}/submissions/{submissionId}/analytics',
    ...options,
  });

/**
 * Retrieves analytics for one of the current user's own submissions.
 */
export const getAnalyticsForMySubmission = <ThrowOnError extends boolean = true>(
  options: Options<GetAnalyticsForMySubmissionData, ThrowOnError>,
): RequestResult<GetAnalyticsForMySubmissionResponses, GetAnalyticsForMySubmissionErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).get<
    GetAnalyticsForMySubmissionResponses,
    GetAnalyticsForMySubmissionErrors,
    ThrowOnError,
    'data'
  >({
    responseStyle: 'data',
    url: '/profile/me/submissions/{submissionId}/analytics',
    ...options,
  });

/**
 * Retrieves all submissions for a given profile.
 */
export const getSubmissions = <ThrowOnError extends boolean = true>(
  options: Options<GetSubmissionsData, ThrowOnError>,
): RequestResult<GetSubmissionsResponses, GetSubmissionsErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).get<GetSubmissionsResponses, GetSubmissionsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/profile/{profileId}/submissions',
    ...options,
  });

/**
 * Retrieves all of the current user's own submissions.
 */
export const getMySubmissions = <ThrowOnError extends boolean = true>(
  options?: Options<GetMySubmissionsData, ThrowOnError>,
): RequestResult<GetMySubmissionsResponses, GetMySubmissionsErrors, ThrowOnError, 'data'> =>
  (options?.client ?? client).get<GetMySubmissionsResponses, GetMySubmissionsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/profile/me/submissions',
    ...options,
  });

/**
 * Creates a new submission for the current user against a survey, creating an anonymous profile first if needed.
 */
export const createSubmission = <ThrowOnError extends boolean = true>(
  options: Options<CreateSubmissionData, ThrowOnError>,
): RequestResult<CreateSubmissionResponses, unknown, ThrowOnError, 'data'> =>
  (options.client ?? client).post<CreateSubmissionResponses, unknown, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/profile/me/submissions',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Soft-deletes a profile and all of its submissions.
 */
export const deleteProfile = <ThrowOnError extends boolean = true>(
  options: Options<DeleteProfileData, ThrowOnError>,
): RequestResult<DeleteProfileResponses, DeleteProfileErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).delete<DeleteProfileResponses, DeleteProfileErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/profile/{profileId}',
    ...options,
  });

/**
 * Retrieves a profile by ID.
 */
export const getProfile = <ThrowOnError extends boolean = true>(
  options: Options<GetProfileData, ThrowOnError>,
): RequestResult<GetProfileResponses, GetProfileErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).get<GetProfileResponses, GetProfileErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/profile/{profileId}',
    ...options,
  });

/**
 * Retrieves the current user's own profile, signing them out if the profile can no longer be found.
 */
export const getMyProfile = <ThrowOnError extends boolean = true>(
  options?: Options<GetMyProfileData, ThrowOnError>,
): RequestResult<GetMyProfileResponses, GetMyProfileErrors, ThrowOnError, 'data'> =>
  (options?.client ?? client).get<GetMyProfileResponses, GetMyProfileErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/profile/me',
    ...options,
  });

/**
 * Soft-deletes every test profile and all of their submissions.
 */
export const deleteTestProfiles = <ThrowOnError extends boolean = true>(
  options: Options<DeleteTestProfilesData, ThrowOnError>,
): RequestResult<DeleteTestProfilesResponses, DeleteTestProfilesErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).delete<DeleteTestProfilesResponses, DeleteTestProfilesErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/profile',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Searches profiles with optional filtering and pagination.
 */
export const searchProfiles = <ThrowOnError extends boolean = true>(
  options: Options<SearchProfilesData, ThrowOnError>,
): RequestResult<SearchProfilesResponses, SearchProfilesErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).get<SearchProfilesResponses, SearchProfilesErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/profile',
    ...options,
  });

/**
 * Signs in as the first profile matching a search query, without requiring OAuth credentials.
 * Intended for local development only.
 */
export const localSignInEndpoint = <ThrowOnError extends boolean = true>(
  options: Options<LocalSignInEndpointData, ThrowOnError>,
): RequestResult<LocalSignInEndpointResponses, unknown, ThrowOnError, 'data'> =>
  (options.client ?? client).get<LocalSignInEndpointResponses, unknown, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/local/sign-in',
    ...options,
  });

/**
 * Signs out the currently authenticated user.
 */
export const logout = <ThrowOnError extends boolean = true>(
  options?: Options<LogoutData, ThrowOnError>,
): RequestResult<LogoutResponses, unknown, ThrowOnError, 'data'> =>
  (options?.client ?? client).post<LogoutResponses, unknown, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/auth/logout',
    ...options,
  });

/**
 * Validates an OAuth access token and signs the associated user in, creating or attaching a profile as needed.
 */
export const oAuthSignIn = <ThrowOnError extends boolean = true>(
  options: Options<OAuthSignInData, ThrowOnError>,
): RequestResult<OAuthSignInResponses, OAuthSignInErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).post<OAuthSignInResponses, OAuthSignInErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/auth/oauth-signin',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
